import { JsonObject, JsonProperty } from 'json2typescript';
import { Entity } from '../entity';

@JsonObject('filters')
export class Filters extends Entity {
  @JsonProperty('name', String)
  name?: string = undefined;
  @JsonProperty('table', String, true)
  table?: string = undefined;
  @JsonProperty('values', [String])
  values?: string[] = undefined; 
}